// src/hooks/useCopyToClipboard.js
import { useState, useCallback } from 'react';

/**
 * Per-key copy-to-clipboard state, extracted from the OrderListPage pattern.
 * Usage: const { copy, isCopied } = useCopyToClipboard(); copy(text, key); isCopied(key)
 */
export const useCopyToClipboard = (resetMs = 2000) => {
  const [copiedStates, setCopiedStates] = useState({});

  const copy = useCallback(async (text, key) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedStates(prev => ({ ...prev, [key]: true }));
      setTimeout(() => setCopiedStates(prev => ({ ...prev, [key]: false })), resetMs);
      return true;
    } catch (err) {
      console.error('Failed to copy:', err);
      return false;
    }
  }, [resetMs]);

  const isCopied = useCallback((key) => !!copiedStates[key], [copiedStates]);

  return { copy, isCopied };
};

export default useCopyToClipboard;
